/** Canonical MyCarSlot public contact info — single source for phone, email, address. */

export const DEALERSHIP_PHONE_DISPLAY = '(228) 202-9614';
export const DEALERSHIP_PHONE_DISPLAY_INTL = '+1 (228) 202-9614';
export const DEALERSHIP_PHONE_E164 = '+12282029614';
export const DEALERSHIP_PHONE_TEL_URI = `tel:${DEALERSHIP_PHONE_E164}`;

export const DEALERSHIP_EMAIL = 'sales@mycarslot.com';

export const DEALERSHIP_ADDRESS = {
  line1: '6314 Washington Ave',
  line2: 'Ocean Springs, MS 39564',
  full: '6314 Washington Ave, Ocean Springs, MS 39564',
  mapsEmbed:
    'https://www.google.com/maps?q=6314+Washington+Ave,+Ocean+Springs,+MS+39564&hl=en&z=15&output=embed',
  mapsDirections:
    'https://www.google.com/maps/dir/?api=1&destination=6314+Washington+Ave,+Ocean+Springs,+MS+39564',
};
